// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"44b2235e","792":"44b2235e"}[chunkId] + ".chunk.css";
};